import type { FluxErrorEntityErrorCodes } from '../types.js';

export const AutomationActionErrorCodes = {
  AutomationActionAssigneeMustBeGreaterThan1: {
    code: 'automation-action/assignee-must-be-greater-than-1',
    message: 'O número de responsáveis atribuídos deve ser maior do que um para habilitar a roleta.',
    explanation: 'Para esta ação de automação, é necessário atribuir mais de um responsável. A roleta de responsáveis só pode ser ativada com múltiplos responsáveis.',
    localizations: {},
  },
  AutomationActionAssigneeRequired: {
    code: 'automation-action/assignee-required',
    message: 'É necessário definir pelo menos um responsável para esta ação de automação.',
    explanation: 'Esta ação de automação requer que pelo menos um responsável seja definido, seja para atribuição direta ou roleta de responsáveis.',
    localizations: {},
  },
  AutomationActionCreateFailed: {
    code: 'automation-action/create-failed',
    message: 'Não foi possível criar a ação de automação. Verifique suas informações e tente novamente.',
    explanation: 'Ocorreu um erro desconhecido ao tentar criar a ação de automação. Verifique os dados fornecidos e tente novamente.',
    localizations: {},
  },
  AutomationActionMissingRequiredFields: {
    code: 'automation-action/missing-required-fields',
    message: 'Alguns campos obrigatórios não foram preenchidos. Complete as informações e tente novamente.',
    explanation: 'Um ou mais campos obrigatórios para esta ação de automação não foram preenchidos. Cada tipo de ação pode ter campos diferentes com requisitos específicos.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Criando sua automação',
        path: '/wiki/docs/automations/criando-sua-automacao',
      },
    ],
  },
  AutomationActionNotFound: {
    code: 'automation-action/not-found',
    message: 'A ação de automação especificada não foi encontrada.',
    explanation: 'A ação de automação que você está tentando acessar não foi encontrada.',
    localizations: {},
  },
  AutomationActionRequired: {
    code: 'automation-action/required',
    message: 'Uma ação de automação é obrigatória para concluir esta operação.',
    explanation: 'Para continuar com esta operação, é necessário definir uma ação de automação.',
    localizations: {},
  },
  AutomationActionSyncOnlySupportHttpRequest: {
    code: 'automation-action/sync-only-support-http-request',
    message: 'Este tipo de automação síncrona aceita apenas requisições HTTP.',
    explanation: 'A automação síncrona que você está tentando usar suporta apenas requisições do tipo HTTP.',
    localizations: {},
  },
  AutomationActionSyncOnlySupportPost: {
    code: 'automation-action/sync-only-support-post',
    message: 'A automação síncrona permite apenas requisições do tipo POST.',
    explanation: 'Para esta automação síncrona, apenas requisições do tipo POST são permitidas.',
    localizations: {},
  },
  AutomationActionUpdateFailed: {
    code: 'automation-action/update-failed',
    message: 'Erro ao atualizar a ação de automação. Tente novamente mais tarde.',
    explanation: 'Ocorreu um erro desconhecido ao tentar atualizar a ação de automação. Verifique os dados fornecidos e tente novamente.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-action'>;

export const AutomationErrorCodes = {
  AutomationCreateFailed: {
    code: 'automation/create-failed',
    message: 'Falha ao criar a automação.',
    explanation: 'Ocorreu um erro desconhecido ao tentar criar a automação. Verifique as informações e tente novamente.',
    localizations: {},
  },
  AutomationNotFound: {
    code: 'automation/not-found',
    message: 'A automação solicitada não foi encontrada.',
    explanation: 'A automação que você está tentando acessar não foi encontrada.',
    localizations: {},
  },
  AutomationRequired: {
    code: 'automation/required',
    message: 'Uma automação é necessária para prosseguir com esta operação.',
    explanation: 'Para continuar com esta operação, é necessário definir uma automação.',
    localizations: {},
  },
  AutomationToggleArchive: {
    code: 'automation/toggle-archive',
    message: 'Não foi possível alterar o status de arquivamento da automação.',
    explanation: 'Ocorreu um erro desconhecido ao tentar arquivar ou desarquivar a automação. Verifique as informações e tente novamente.',
    localizations: {},
  },
  AutomationUpdateFailed: {
    code: 'automation/update-failed',
    message: 'Houve um erro ao atualizar a automação.',
    explanation: 'Ocorreu um erro desconhecido ao tentar atualizar a automação. Verifique as informações e tente novamente.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation'>;

export const SyncAutomationErrorCodes = {
  SyncAutomationInvalidAutomationExecutionAction: {
    code: 'sync-automation/invalid-automation-execution-action',
    message: 'Ação de execução de automação inválida.',
    explanation: 'A ação de execução da automação síncrona é inválida.',
    localizations: {},
  },
  SyncAutomationInvalidStatus: {
    code: 'sync-automation/invalid-status',
    message: 'O status informado é inválido.',
    explanation: 'O status fornecido para a automação síncrona é inválido.',
    localizations: {},
  },
  SyncAutomationNotFound: {
    code: 'sync-automation/not-found',
    message: 'Automação não encontrada.',
    explanation: 'A automação síncrona que você está tentando acessar não foi encontrada.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'sync-automation'>;
